(function () {
  'use strict';

  function rootPath() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function track(eventName, detail) {
    var payload = detail || {};
    payload.event = eventName;
    document.dispatchEvent(new CustomEvent('ln:event', { detail: payload }));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cardStep(trackNode) {
    var card = trackNode.querySelector('[data-ln-swipe-card]');
    if (!card) return Math.max(trackNode.clientWidth * 0.82, 260);
    var styles = window.getComputedStyle(trackNode);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function initSwipe(shell) {
    if (shell.dataset.lnSwipeReady === 'true') return;
    shell.dataset.lnSwipeReady = 'true';

    var trackNode = shell.querySelector('[data-ln-swipe-track]');
    var cards = trackNode ? Array.prototype.slice.call(trackNode.querySelectorAll('[data-ln-swipe-card]')) : [];
    var previous = shell.querySelector('[data-ln-swipe-prev]');
    var next = shell.querySelector('[data-ln-swipe-next]');
    var progress = shell.querySelector('[data-ln-swipe-progress]');
    var lastIndex = -1;
    var frame = null;

    if (!trackNode || cards.length === 0) return;

    function currentIndex() {
      var step = cardStep(trackNode);
      return Math.max(0, Math.min(cards.length - 1, Math.round(trackNode.scrollLeft / Math.max(step, 1))));
    }

    function update() {
      frame = null;
      var index = currentIndex();

      if (progress) progress.textContent = (index + 1) + ' / ' + cards.length;
      var maxScroll = Math.max(0, trackNode.scrollWidth - trackNode.clientWidth);
      var hasOverflow = maxScroll > 2;
      if (previous) { previous.disabled = trackNode.scrollLeft <= 2; previous.hidden = !hasOverflow; }
      if (next) { next.disabled = trackNode.scrollLeft >= maxScroll - 2; next.hidden = !hasOverflow; }
      if (progress) progress.hidden = !hasOverflow || trackNode.clientWidth > cardStep(trackNode) * 1.5;

      if (index !== lastIndex) {
        lastIndex = index;
        track('product_swipe_card_view', {
          placement: shell.dataset.lnSwipePlacement || '',
          product_handle: shell.dataset.lnProduct || '',
          card_index: index + 1,
          card_count: cards.length
        });
      }
    }

    function scheduleUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    function move(direction) {
      trackNode.scrollBy({
        left: cardStep(trackNode) * direction,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
      track('product_swipe_control', {
        placement: shell.dataset.lnSwipePlacement || '',
        product_handle: shell.dataset.lnProduct || '',
        direction: direction > 0 ? 'next' : 'previous'
      });
    }

    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    trackNode.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    update();
  }

  function initJumpButtons() {
    document.querySelectorAll('[data-ln-jump-buy]').forEach(function (button) {
      if (button.dataset.lnJumpReady === 'true') return;
      button.dataset.lnJumpReady = 'true';

      button.addEventListener('click', function () {
        var form = document.getElementById('ln-product-form');
        var target = form || document.querySelector('.ln-pdp__info') || document.body;
        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'center'
        });

        track('product_midpage_cta', {
          product_handle: button.dataset.lnProduct || '',
          placement: button.dataset.lnPlacement || ''
        });

        window.setTimeout(function () {
          var add = document.getElementById('ln-add-btn');
          if (add && !add.disabled) add.focus({ preventScroll: true });
        }, prefersReducedMotion() ? 0 : 450);
      });
    });
  }

  function initQuickAdd(button) {
    if (button.dataset.lnQuickReady === 'true') return;
    button.dataset.lnQuickReady = 'true';
    var feedback = document.createElement('p');
    feedback.className = 'ln-quick-add-feedback';
    feedback.setAttribute('role', 'status');
    feedback.setAttribute('aria-live', 'polite');
    feedback.style.cssText = 'font-size:.82rem;line-height:1.5;margin:.5rem 0;';
    feedback.hidden = true;
    button.insertAdjacentElement('afterend', feedback);

    button.addEventListener('click', function () {
      if (button.dataset.added === 'true') {
        window.location.assign(rootPath() + 'cart');
        return;
      }

      var variantId = parseInt(button.dataset.variantId || '0', 10);
      if (!variantId) return;

      var original = button.textContent;
      feedback.hidden = true;
      button.removeAttribute('title');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Lægger i kurven...';

      track('comparison_quick_add_attempt', {
        source_product: button.dataset.sourceProduct || '',
        target_product: button.dataset.targetProduct || '',
        variant_id: String(variantId),
        placement: button.dataset.lnPlacement || 'comparison'
      });

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _ln_source: button.dataset.sourceProduct || '',
              _ln_placement: button.dataset.lnPlacement || 'comparison'
            }
          }]
        })
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.description || payload.message || 'Varen kunne ikke lægges i kurven.');
            return payload;
          });
        })
        .then(function () {
          button.dataset.added = 'true';
          button.classList.add('is-added');
          button.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = 'Lagt i kurven - se kurv';
          feedback.textContent = button.textContent;
          feedback.hidden = false;
          fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { if (!response.ok) throw new Error('Cart refresh failed'); return response.json(); })
            .then(function (cart) {
              document.querySelectorAll('.ln10-header__cart').forEach(function (link) {
                var badge = link.querySelector('span');
                if (!badge) { badge = document.createElement('span'); link.appendChild(badge); }
                badge.textContent = String(cart.item_count);
                link.setAttribute('aria-label', 'Indkøbskurv med ' + cart.item_count + ' varer');
              });
            }).catch(function () { /* Purchase succeeded; the explicit cart link remains available. */ });

          track('comparison_quick_add_success', {
            source_product: button.dataset.sourceProduct || '',
            target_product: button.dataset.targetProduct || '',
            variant_id: String(variantId),
            placement: button.dataset.lnPlacement || 'comparison'
          });
        })
        .catch(function (error) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = original;
          feedback.textContent = error.message;
          feedback.hidden = false;

          track('comparison_quick_add_error', {
            source_product: button.dataset.sourceProduct || '',
            target_product: button.dataset.targetProduct || '',
            variant_id: String(variantId),
            error_message: String(error.message || 'Ukendt fejl').slice(0, 180)
          });
        });
    });
  }

  function initVideo(section) {
    if (section.dataset.lnVideoReady === 'true') return;
    section.dataset.lnVideoReady = 'true';

    var video = section.querySelector('video');
    if (!video) return;

    var tracked = false;
    video.addEventListener('play', function () {
      if (tracked) return;
      tracked = true;
      track('product_video_play', {
        product_handle: section.dataset.lnProduct || '',
        placement: 'product_page'
      });
    });
  }

  function initTrackedLinks() {
    document.querySelectorAll('[data-ln-product-link]').forEach(function (link) {
      if (link.dataset.lnLinkReady === 'true') return;
      link.dataset.lnLinkReady = 'true';
      link.addEventListener('click', function () {
        track('product_recommendation_click', {
          source_product: link.dataset.sourceProduct || '',
          target_product: link.dataset.targetProduct || '',
          placement: link.dataset.lnPlacement || ''
        });
      });
    });
  }


  function initAddonSwipeScaffolds() {
    document.querySelectorAll('[data-ln-buy-together]').forEach(function (section) {
      if (section.dataset.lnAddonSwipeReady === 'true') return;
      section.dataset.lnAddonSwipeReady = 'true';

      var grid = section.querySelector('.ln-buy-together__grid');
      var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-ln-addon-card]')) : [];
      if (!grid || cards.length < 2) return;

      section.setAttribute('data-ln-swipe', '');
      section.dataset.lnSwipePlacement = 'add_ons';
      section.dataset.lnProduct = section.dataset.baseHandle || '';
      grid.setAttribute('data-ln-swipe-track', '');
      grid.setAttribute('tabindex', '0');
      grid.setAttribute('aria-label', cards.length + ' valgbare tilkøb');

      cards.forEach(function (card) {
        card.setAttribute('data-ln-swipe-card', '');
      });

      var controls = document.createElement('div');
      controls.className = 'ln-swipe-controls ln-addon-swipe-controls';
      controls.innerHTML =
        '<p class="ln-swipe-controls__hint">Swipe mellem tilkøb</p>' +
        '<p class="ln-swipe-controls__progress" data-ln-swipe-progress aria-live="polite">1 / ' + cards.length + '</p>';
      grid.insertAdjacentElement('afterend', controls);

      initSwipe(section);
    });
  }


  function initFinalAddTracking() {
    document.querySelectorAll('[data-ln-final-add]').forEach(function (button) {
      if (button.dataset.lnFinalReady === 'true') return;
      button.dataset.lnFinalReady = 'true';
      button.addEventListener('click', function () {
        track('product_final_add_click', {
          product_handle: button.dataset.lnProduct || '',
          placement: 'product_page_footer'
        });
      });
    });
  }

  function initAll() {
    initAddonSwipeScaffolds();
    document.querySelectorAll('[data-ln-swipe]').forEach(initSwipe);
    document.querySelectorAll('[data-ln-quick-add]').forEach(initQuickAdd);
    document.querySelectorAll('[data-ln-product-video]').forEach(initVideo);
    initJumpButtons();
    initTrackedLinks();
    initFinalAddTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
